export default __webpack_public_path__ + "img/fieldtime-settings.5cda53.svg";